import type { Location } from 'react-router'
import { StaticPage } from '@/pages/StaticPage'
import { buildStaticPageMeta } from '@/lib/pageMeta'

export function meta({ location }: { location: Location }) {
  return buildStaticPageMeta(location.pathname)
}

export default StaticPage
